import {Swiper, Pagination, EffectFade, Autoplay} from 'swiper/dist/js/swiper.esm.js'
import {forEach} from "../../js/helpers";

Swiper.use([Pagination, EffectFade, Autoplay]);

(function () {
  const sliderMain = document.querySelector('.sliderMain');
  if (!sliderMain) return;
  const pagination = sliderMain.querySelector('.swiper-pagination');
  const delay = 9000;
  pagination.style.setProperty('--delay', delay+'ms');
  new Swiper(sliderMain, {
      speed: 500,
      autoplay: {
        delay: delay,
      },
      slidesPerView: 1,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      pagination: {
        el: pagination,
        type: 'bullets',
        clickable: true,
      },
      on: {
        paginationUpdate: function (self, pagi) {
          const paginationItems = pagi.children;
          if (self.activeIndex === self.slides.length-1) {
            setTimeout(function () {
              removePagiActiveClass(paginationItems);
            }, delay);
          }
          setTimeout(function () {
            paginationItems[self.activeIndex].classList.add('is-active')
          }, 100);
          pagi.setAttribute('data-theme', this.slides[this.activeIndex].dataset.theme);
        },
      }
    }
  );

  function removePagiActiveClass(paginationItems) {
    forEach(paginationItems, (item) => {
      item.classList.remove('is-active');
    });
  }

})();